import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { ButtonRow, theme } from '@omnigenbiodata/ui';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';
import { AiOutlineCheckCircle } from 'react-icons/ai';
import QRCode from 'react-qr-code';
import { Flags } from 'react-feature-flags';
import { useAppDispatch, useAppSelector } from '../../../../store';
import { responseSelector } from '../../../../store/user';
import { resetHasChecked } from '../../../../store/participant';
import { FEATURES } from '../../../../core/constants/features.constants';

function SuccessStep() {
  const { t } = useTranslation('portal');
  const dispatch = useAppDispatch();
  const pid = useAppSelector(responseSelector);

  const qrValue = pid == null ? '' : String(pid);

  return (
    <>
      <Grid container>
        <Grid item xs={1} sm={2} md={1} />

        <Grid item xs={10} sm={8} md={10}>
          <Box mb={4} px={5}>
            <Box textAlign="center">
              <AiOutlineCheckCircle fontSize={90} color={theme.palette.success.main} aria-hidden="true" />
            </Box>

            <Typography variant="h4" component="h1" align="center" gutterBottom>
              {t('enrol.success.title')}
            </Typography>

            <Box textAlign="center">
              <ReactMarkdown>{t('enrol.success.text')}</ReactMarkdown>
            </Box>

            <Box
              mt={4}
              p={3}
              sx={{
                border: 1,
                borderColor: 'primary.main',
                borderRadius: 2,
                bgcolor: 'background.paper',
              }}
            >
              <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 700 }}>
                {t('enrol.success.sampleTitle')}
              </Typography>

              <Typography variant="body1" paragraph>
                {t('enrol.success.sampleEventText')}
              </Typography>
              <Flags authorizedFlags={[FEATURES.COMMUNITY_ENROLMENT]}>
                {qrValue ? (
                  <Box
                    role="img"
                    aria-label="QR code for linking your saliva sample"
                    sx={{
                      width: '100%',
                      maxWidth: 360,
                      mx: 'auto',
                      my: 4,
                      p: 2,
                      bgcolor: '#fff',
                      borderRadius: 2,
                      boxSizing: 'border-box',
                    }}
                  >
                    <QRCode
                      value={qrValue}
                      size={320}
                      style={{
                        display: 'block',
                        width: '100%',
                        height: 'auto',
                      }}
                    />
                  </Box>
                ) : (
                  <Typography role="status" color="text.secondary" align="center" sx={{ my: 4 }}>
                    {t('enrol.success.samplePostText')}
                  </Typography>
                )}
              </Flags>

              <Typography variant="body1">{t('enrol.success.samplePostText')}</Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <ButtonRow
        buttonSize="medium"
        showBack={false}
        justifyContent="center"
        forwardColor="primary"
        forwardLabel={t('enrol.success.button') as string}
        onForward={() => {
          dispatch(resetHasChecked());
        }}
      />
    </>
  );
}

export default SuccessStep;
